import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import MediumSelect from './Components/MediumSelect';
import PhotoScroll from './Components/PhotoScroll';
import ListSubheader from '@material-ui/core/ListSubheader';


const styles = theme => ({
root: {
  display: 'flex',
   flexWrap: 'wrap',
   justifyContent: 'space-around',
   overflow: 'hidden',
   backgroundColor: '#66d5ed',
   height: '38em',
   color: '#fff',
  paddingTop: '3em',
},
header: {
  paddingTop: '3em',
},
});


const getArt = (url) => {
  return fetch(url).then(res => res.json())
}

class Work extends Component{
  constructor(){
    super();
    this.state={
      apiInfo:[],
      workTypes : [
       {
         value: 'Web',
         label: 'Web Devepolment',
       },
       {
         value: 'Art',
         label: 'Painting',
       },
       {
         value: 'Photos',
         label: 'Photograghy',
       },
     ],
      value:'Web',
      open: false,
      id: 0,
      popData: [],
      loading:false
   }
  }

  componentDidMount(){

    getArt(`/API/Web.json`)
      .then(data => {
      let workData = data.map(el => el)
      this.setState({ apiInfo:workData})
    })
  }

  handleWorkChange =(e)=>{
    const value = e.target.value

    getArt(`/API/${value}.json`)
      .then(data => {
      let workData = data.map(el => el)
      !workData ?
      this.setState({loading: true})
      :
      this.setState({ apiInfo:workData})
    })
    this.setState({value: value})
  }

  handleClickOpen = (e) => {
  this.state.apiInfo.find(el=>{
    return el.id === parseInt( e.target.id) ?
    this.setState({popData:el})
    : null
  })
    const target = e.target
    this.setState({open:true})
    this.setState({ id: target.id})
  }

  handleClose = () => {
    this.setState({open:false})
  }




  render (){
    const { classes } = this.props;
    const {loading,value, apiInfo, workTypes, open,id, popData} = this.state
    console.log('popData', loading);
    return (
      <Grid container className={classes.root}>
        <Grid item xs={12}>

           <ListSubheader component="div" style={{ fontSize:'3em', color: '#fff' }}>Portfolio</ListSubheader>

          <Grid
            container
            direction="row"
            justify= 'space-around'
            alignItems="start"
            className={classes.header}
          >
            <Grid>
              <MediumSelect
                value={value}
                workTypes={workTypes}
                handleChange={this.handleWorkChange}
              />
              </Grid>
              <Grid>
              <PhotoScroll
                loading={loading}
                tileData={apiInfo}
                open={open}
                id={id}
                popData={popData}
                handleClose={this.handleClose}
                handleClickOpen={this.handleClickOpen}
              />
              </Grid>





          </Grid>

        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Work)
